import React from 'react';
import cx from 'classnames';

interface Props {
  tailwindColor?: string;
  className?: string;
  height?: number;
}

const HeadphonesIcon: React.FC<Props> = ({
  tailwindColor = `white`,
  className,
  height = 40,
}) => (
  <svg
    className={cx(className, `inline-block`)}
    width={height}
    height={height}
    viewBox="0 0 40 40"
  >
    <path
      className={cx(`text-${tailwindColor}`, `fill-current`)}
      d="M29.4222222,18.1834586 L29.1,18.1834586 L29.1,17.8483351 C29.1,12.8556649 25.2004667,8.8 20.4,8.8 C15.5995333,8.8 11.7,12.8556649 11.7,17.8483351 L11.7,18.1834586 L11.3777778,18.1834586 C9.96051556,18.1834586 8.8,19.3904395 8.8,20.8644468 L8.8,25.2210526 C8.8,26.6950599 9.96051556,27.9020408 11.3777778,27.9020408 L14.2777778,27.9020408 L14.2777778,18.1834586 L12.9888889,18.1834586 L12.9888889,17.8483351 C12.9888889,13.5926015 16.3081,10.1404941 20.4,10.1404941 C24.4919,10.1404941 27.8111111,13.5926015 27.8111111,17.8483351 L27.8111111,18.1834586 L26.5222222,18.1834586 L26.5222222,27.9020408 L29.4222222,27.9020408 C30.8394844,27.9020408 32,26.6950599 32,25.2210526 L32,20.8644468 C32,19.3904395 30.8722222,18.1834586 29.4222222,18.1834586 Z M12.9888889,19.5239527 L12.9888889,26.5615467 L11.3777778,26.5615467 C10.6691467,26.5615467 10.0888889,25.9580563 10.0888889,25.2210526 L10.0888889,20.8644468 C10.0888889,20.1274432 10.6691467,19.5239527 11.3777778,19.5239527 L12.9888889,19.5239527 Z M30.7111111,25.2210526 C30.7111111,25.9580563 30.1308533,26.5615467 29.4222222,26.5615467 L27.8111111,26.5615467 L27.8111111,19.5239527 L29.4222222,19.5239527 C30.1308533,19.5239527 30.7111111,20.1274432 30.7111111,20.8644468 L30.7111111,25.2210526 Z"
    />
  </svg>
);

export default HeadphonesIcon;
